const extensoesSuporte = [
  'pdf',
  'png',
  'gif',
  'jpg',
  'jpeg',
  'svg',
  'txt',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'avi',
  'mp4',
  'mov'
];

export default extensoesSuporte;
